import React from 'react';
import { Link } from 'react-router-dom';

const HubPage = () => (
  <main data-testid="hub-page" className="pt-24">
    <section className="py-24">
      <div className="max-w-5xl mx-auto px-6">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">Digital Hub Sociale</p>
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-8">
          AI_COVO<br />
          <span className="text-zinc-500">L'evoluzione.</span>
        </h1>
        
        <div className="prose prose-invert prose-lg max-w-none space-y-8">
          <div className="border-l-4 border-[#00FF41] pl-8 py-4 bg-[#00FF41]/5">
            <p className="text-xl text-white font-medium m-0">
              Il coworking è uno spazio condiviso da professionisti indipendenti per ridurre i costi.
              AI_COVO è la sua evoluzione.
            </p>
          </div>
          
          <p className="text-zinc-400 leading-relaxed">
            Mentre il coworking si limita spesso alla condivisione di scrivanie, 
            <strong className="text-white"> AI_COVO è un ecosistema</strong> che offre:
          </p>
          
          <div className="grid md:grid-cols-3 gap-6 my-12">
            {[
              { title: 'Networking', desc: 'Connessioni strutturate tra professionisti, associazioni e istituzioni' },
              { title: 'Innovazione', desc: 'Tecnologia e formazione digitale per tutti' },
              { title: 'Well-being', desc: 'Benessere sociale, inclusione, supporto alla comunità' },
            ].map((item, i) => (
              <div key={i} className="bg-[#0A0A0A] border border-[#00FF41]/30 p-6">
                <h3 className="text-[#00FF41] font-bold mb-2">{item.title}</h3>
                <p className="text-zinc-400 text-sm m-0">{item.desc}</p>
              </div>
            ))}
          </div>

          <h2 className="text-2xl font-bold text-white mt-16 mb-6">La Mission</h2>
          
          <p className="text-zinc-400 leading-relaxed">
            Chi pensa a ridare gli spazi ad una generazione a cui è stato tolto quasi tutto 
            quello che avevano i loro genitori? Spazi comuni, possibilità, opportunità.
          </p>
          
          <p className="text-zinc-400 leading-relaxed">
            Ci lamentiamo dei giovani e del loro starsene sempre in casa davanti al tablet 
            ma... <strong className="text-white">quali alternative hanno?</strong>
          </p>
          
          <div className="bg-[#0A0A0A] border border-[#00FF41]/30 p-8 my-12">
            <p className="text-2xl font-bold text-[#00FF41] m-0">
              Lo faremo noi. AI_COVO.
            </p>
          </div>

          <h2 className="text-2xl font-bold text-white mt-16 mb-6">Il Contesto</h2>
          
          <p className="text-zinc-400 leading-relaxed">
            Rispetto al Nord Europa, l'Italia è rimasta indietro nei servizi pubblici. 
            Troppo indietro. <span className="text-white">Colpevolmente indietro.</span>
          </p>
          
          <p className="text-zinc-400 leading-relaxed">
            Fino ad oggi, nessuno ha saputo rispondere ai micro-problemi del tessuto sociale. 
            AI_COVO nasce per colmare questo vuoto, con un modello replicabile in tutta Italia.
          </p>
        </div>
        
        <div className="mt-16 text-center">
          <Link to="/dona" className="btn-primary bg-[#00FF41] text-black border-[#00FF41] hover:bg-[#33FF66]">
            Sostieni AI_COVO
          </Link>
        </div>
      </div>
    </section>
  </main>
);

export default HubPage;
